import { Pin } from '@lessonup/pins-shared';
import React from 'react';
import { UnsupportedPinStatic } from '../../../pins';
import { AnswerByCategoryPinComponent } from '../../../pins/AnswerByCategoryPin/AnswerByCategoryPin';
import { DragAndDropPinComponent } from '../../../pins/DragAndDropPin/DragAndDropPin';
import { PollPinComponent } from '../../../pins/PollPin/PollPin';
import { SlidePinComponent } from '../../../pins/SlidePin/SlidePin';
import { SortingQuestionPin } from '../../../pins/SortingQuestionPin/SortingQuestionPin';
import { FillInTheBlanksPinStatic } from './pins/FillInTheBlanksPinStatic';
import { OpenQuestionPinStatic } from './pins/OpenQuestionPinStatic';
import { QuizPinStatic } from './pins/QuizPinStatic';
import { WordCloudPinStatic } from './pins/WordCloudPinStatic';

export interface PinSwitchStaticProps {
  pin: Pin;
  isThumb?: boolean;
  children?: React.ReactNode;
}

export const PinSwitchStatic: React.FC<PinSwitchStaticProps> = ({ pin, isThumb, children }) => {
  const type = pin.type;
  switch (type) {
    case 'SLIDE':
      return (
        <SlidePinComponent pinSettings={pin.settings} isThumb={isThumb}>
          {children}
        </SlidePinComponent>
      );
    case 'MULTIPLE_CHOICE':
      return (
        <QuizPinStatic pinSettings={pin.settings} isThumb={isThumb}>
          {children}
        </QuizPinStatic>
      );
    case 'OPEN_QUESTION':
      return (
        <OpenQuestionPinStatic pinSettings={pin.settings} isThumb={isThumb}>
          {children}
        </OpenQuestionPinStatic>
      );
    case 'WORD_CLOUD':
      return (
        <WordCloudPinStatic pinSettings={pin.settings} isThumb={isThumb}>
          {children}
        </WordCloudPinStatic>
      );
    case 'FILL_IN_THE_BLANKS':
      return (
        <FillInTheBlanksPinStatic pinSettings={pin.settings} isThumb={isThumb}>
          {children}
        </FillInTheBlanksPinStatic>
      );
    case 'UNSUPPORTED':
      return (
        <UnsupportedPinStatic pinSettings={pin.settings} isThumb={isThumb}>
          {children}
        </UnsupportedPinStatic>
      );
    case 'POLL':
      return (
        <PollPinComponent pinSettings={pin.settings} isThumb={isThumb}>
          {children}
        </PollPinComponent>
      );
    case 'ANSWER_BY_CATEGORY':
      return (
        <AnswerByCategoryPinComponent pinSettings={pin.settings} isThumb={isThumb}>
          {children}
        </AnswerByCategoryPinComponent>
      );
    case 'SORTING_QUESTION':
      return (
        <SortingQuestionPin pinSettings={pin.settings} isThumb={isThumb}>
          {children}
        </SortingQuestionPin>
      );
    case 'DRAG_AND_DROP':
      return (
        <DragAndDropPinComponent pinSettings={pin.settings} isThumb={isThumb}>
          {children}
        </DragAndDropPinComponent>
      );
    default:
      console.warn(`PinSwitchStatic: unrecognized pin type: ${type}`);
      return null;
  }
};
